export const T = {
  nav: {
    logo: "nav-logo",
    memberships: "nav-memberships",
    manifesto: "nav-manifesto",
    faq: "nav-faq",
    admin: "nav-admin",
  },
  hero: {
    root: "hero-root",
    cta: "hero-cta-choose",
    secondary: "hero-cta-learn-more",
  },
  tier: (id) => `tier-card-${id}`,
  tierSubscribe: (id) => `tier-subscribe-${id}`,
  frequency: (id, freq) => `tier-${id}-freq-${freq}`,
  form: {
    dialog: "subscribe-dialog",
    step1Next: "form-step-1-next",
    step2Next: "form-step-2-next",
    step2Back: "form-step-2-back",
    step3Back: "form-step-3-back",
    submit: "form-submit",
    fullName: "form-full-name",
    phone: "form-phone",
    email: "form-email",
    address: "form-address",
    apartment: "form-apartment",
    day: "form-day",
    time: "form-time",
    instructions: "form-instructions",
    palette: (p) => `form-palette-${p}`,
    payment: (p) => `form-payment-${p}`,
    freq: (f) => `form-freq-${f}`,
    tier: (t) => `form-tier-${t}`,
    close: "form-close",
    confirmation: "form-confirmation",
    giftToggle: "form-gift-toggle",    recipientName: "form-recipient-name",
    giftNote: "form-gift-note",
    upiPay: "form-upi-pay",
    upiTxn: "form-upi-txn",
    markPaid: "form-mark-paid",
    paymentPanel: "form-payment-panel",
  },
  admin: {
    root: "admin-root",
    search: "admin-search",
    filterStatus: "admin-filter-status",
    filterFreq: "admin-filter-freq",
    row: (id) => `admin-row-${id}`,
    pause: (id) => `admin-pause-${id}`,
    resume: (id) => `admin-resume-${id}`,
    cancel: (id) => `admin-cancel-${id}`,
    reschedule: (id) => `admin-reschedule-${id}`,
    rescheduleInput: "admin-reschedule-input",
    rescheduleSave: "admin-reschedule-save",
    statMrr: "stat-mrr",
    statActive: "stat-active",
    statPaused: "stat-paused",
    statWeekly: "stat-weekly",
    statFortnightly: "stat-fortnightly",
    statPendingPayments: "stat-pending-payments",
    verifyPayment: (id) => `admin-verify-${id}`,
    calendarLink: "admin-calendar-link",
    calendarPrev: "calendar-prev",
    calendarNext: "calendar-next",
    calendarDay: (d) => `calendar-day-${d}`,
    logout: "admin-logout",
    loginPassphrase: "admin-login-passphrase",
    loginSubmit: "admin-login-submit",
    loginError: "admin-login-error",
    routeStop: (id) => `route-stop-${id}`,
    driveTime: (d) => `drive-time-${d}`,
    sendTestEmail: "admin-send-test-email",
    testEmailInput: "admin-test-email-input",
    testEmailSubmit: "admin-test-email-submit",
    testEmailResult: "admin-test-email-result",
    changePassphrase: "admin-change-passphrase",
    passCurrent: "pass-current",
    passNew: "pass-new",
    passSubmit: "pass-submit",
    whatsapp: (d) => `whatsapp-${d}`,
    uploadPhoto: (id) => `upload-photo-${id}`,
    deliveredBadge: (id) => `delivered-badge-${id}`,
    photoInput: "photo-file-input",
    photoNote: "photo-note",
    photoSubmit: "photo-submit",
  },
};
